export const GET_PROCUREMENT_TYPES = "GET_PROCUREMENT_TYPES";
export const GET_PROCUREMENT_TYPE = "GET_PROCUREMENT_TYPE";
export const ADD_PROCUREMENT_TYPE = "ADD_PROCUREMENT_TYPE";
export const DELETE_PROCUREMENT_TYPE = "DELETE_PROCUREMENT_TYPE";
export const UPDATE_PROCUREMENT_TYPE = "UPDATE_PROCUREMENT_TYPE";
